<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card">
                <!-- <h5>{{ $t('table.userlist.heading') }}</h5> -->
                <h5>{{ $t('Generals.list.RecruiterList') }}</h5>
                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mb-2 p-flex-column p-flex-lg-row"></div>
               
                <DataTable :value="results" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="name" :header="$t('Generals.list.No')" style="width: 10%">
                        <template #body="{ index }">
                            <span class="p-column-title">No</span>
                            {{ index + 1 }}
                        </template>
                    </Column>
                    <Column :header="$t('Generals.list.Title')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Title</span>
                            {{ data.title }}
                        </template>
                    </Column>
                    <Column :header="$t('Generals.list.Action')" style="width: 14%">
                        <template #body="{ data }">
                            <span class="p-column-title">Action</span>
                            <p style="display: none">{{ data.status }}</p>
                            <div style="display: flex">
                                <!-- <router-link :to="'/ServiceTerms/ViewServiceTerms/' + data.update_key"
                                    ><Button label="info" class="p-button p-mr-2 p-mb-2"><i class="pi pi-eye p-mr-2"></i></Button>
                                </router-link> -->
                                <router-link :to="'/General/EditGeneral/' + data.update_key"
                                    ><Button label="help" class="p-button2"><i class="pi pi-user-edit p-mr-2"></i></Button
                                ></router-link>

                                <!-- <Button icon="pi pi-trash" class="p-button p-mr-2 p-mb-2" @click="confirm(data.id)" /> -->
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import GeneralService from '../../service/API/GeneralService';
import axios from 'axios';
import moment from 'moment';
// import ProductService from '../service/ProductService';
// import axios from 'axios';
export default {
    data() {
        return {
            dropdownValues: [{ name: 'active', id: 1 }, { name: 'inactive' }],
            results: [],
            status: '',
            startdate: '',
            enddate: '',
            customer1: null,
            loading1: true,
            user: null,
            result: '',
            statuses: ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'],
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            error: {},
            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },
            totalrecords: '',
            title: '',
            description: '',
            create_date: '',
            id: '',
            notice_id: '',
            information_type:''
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.generalService = new GeneralService();
    },
    mounted() {
        const route = useRoute();
        this.getGLlist();
        console.log(route.params);
        // this.noticeService.getNoticeList(this.title, this.status, this.startdate, this.enddate).then((data) => {
        //     this.customer1 = data;
        //     this.loading1 = false;
        //     this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
        // });
    },
    watch: {},
    methods: {
        getGLlist() {
            // const ServicelistParams = {
            //     information_type: "service",
            // };
            this.loading1 = true;
            this.generalService
                .getGeneralList("general")
                .then((res) => {
                    this.results = res.data.result;
                    // this.totalrecords = res.data.total_records;
                    // this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    console.log(res);
                })
                .catch((err) => console.log(err));
        },

        selects() {
            let xyz = [];
            let data = this.selected;
            for (var a = 0; a < data.length; a++) {
                xyz.push(data[a].id);
            }
            this.selectedItemss = xyz.toString();
            if (this.calendarValue !== '') {
                this.calendarValue = this.calendarValue.toISOString().slice(0, 10);
                console.log(this.calendarValue);
            }
            if (this.calendarValue1 !== '') {
                this.calendarValue1 = this.calendarValue1.toISOString().slice(0, 10) + 1;
                console.log(this.calendarValue1);
            }
        },
        resetUser() {
            this.title = '';
            this.status = '';
            this.error = {};
            this.create_date = '';
            this.enddate = '';
            this.getNClist();
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.startdate = utc;
            this.enddate = utc;
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
            this.startdate = startDate;
            this.enddate = edate;
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
            this.startdate = startDate;
            this.enddate = edate;
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
            this.startdate = startDate;
            this.enddate = edate;
        },
        lastyear() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 365);
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
            this.startdate = startDate;
            this.enddate = edate;
        },

        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            // return value.toLocaleDateString('en-US', {
            //     year: 'numeric',
            //     month: '2-digit',
            //     day: '2-digit',
            // });
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '/' + mm + '/' + dd);
        },
        FormatDate(value) {
            if (value) {
                return moment(String(value)).format('YYYY/MM/DD');
            }
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },

        confirm(id) {
            console.log(id);
            var self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'post', url: `api/v1/admin/notice/delete`, data: { notice_id: id } }).then(function () {});
                    this.getNClist();
                    self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}
.p-fluid {
    .p-button {
        width: auto;
    }
}
.p-button {
    background: white;
    // border: 1px solid white;
    color: black;
}
</style>
